import React from 'react';
import { RouteProps, Route, Redirect } from 'react-router';
import { useAuth0 } from '../AuthProvider';

export const PrivateRoute = ({ component: Component, ...rest }: RouteProps) => {
  const { isAuthenticated } = useAuth0();

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated ? (
          Component && <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/auth/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
